import { useQueryClient } from '@tanstack/react-query';
import putIdentificationManualApiCall from 'api/calls/putIdentificationManualApiCall';
import useAuth from './useAuth';
import useProtectedMutation from './useProtectedMutation';

const useIdentificationManualMutation = () => {
  const queryClient = useQueryClient();
  const { token } = useAuth();
  const mutation = useProtectedMutation(putIdentificationManualApiCall, {
    onSuccess: () => {
      queryClient.invalidateQueries(['getClientApiCall', token]);
    },
  });
  return mutation;
};

export default useIdentificationManualMutation;
